export const languageMap: any = {
  loading_screen: {
    instructions: {
      en: 'PLEASE WAIT WHILE WE CONFIGURE THE APP, IT SHOULD ONLY TAKE A MOMENT.',
      es: 'POR FAVOR ESPERA EN LO QUE CONFIGURAMOS LA APLICACIÓN, DEBERÍA TOMAR UN MOMENTO.',
      fr: "VEUILLEZ PATIENTER PENDANT QUE NOUS CONFIGURONS L'APPLICATION, CELA NE DEVRAIT PRENDRE QU'UN MOMENT.",
    },
  },
  login: {
    instructions_login: {
      en: 'PLEASE PROVIDE YOUR LOGIN CREDENTIALS',
      es: 'POR FAVOR INGRESA TUS CREDENCIALES',
      fr: 'VEUILLEZ FOURNIR VOS IDENTIFIANTS DE CONNEXION',
    },
    instructions_install_id: {
      en: 'PLEASE PROVIDE AN INSTALLATION ID',
      es: 'POR FAVOR INGRESA EL ID DE INSTALACIÓN',
      fr: "VEUILLEZ FOURNIR UN ID D'INSTALLATION",
    },
    user_placeholder: {
      en: 'User',
      es: 'Usuario',
      fr: 'Utilisateur',
    },
    password_placeholder: {
      en: 'Password',
      es: 'Contraseña',
      fr: 'Mot de passe',
    },
    installation_id_placeholder: {
      en: 'Installation Id',
      es: 'Installation Id',
      fr: "ID d'installation",
    },
    installation_id_error: {
      en: 'Invalid installation Id',
      es: 'Número inválido',
      fr: "ID d'installation non valide",
    },
    login_buttton: {
      en: 'LOGIN',
      es: 'VALIDAR',
      fr: 'CONNEXION',
    },
    env_title: {
      en: 'Environment',
      es: 'Ambiente',
      fr: 'Environnement',
    },
  },
  employee_login: {
    instructions_login: {
      en: 'PLEASE PROVIDE YOUR LOGIN CREDENTIALS',
      es: 'POR FAVOR INGRESA TUS CREDENCIALES',
      fr: 'VEUILLEZ FOURNIR VOS IDENTIFIANTS DE CONNEXION',
    },
  },
  landing: {
    title: {
      en: 'WELCOME TO DHL',
      es: 'BIENVENIDO A DHL',
      fr: 'BIENVENUE CHEZ DHL',
    },
    subtitle: {
      en: 'THE WORLD LEADING LOGISTICS COMPANY',
      es: 'LA EMPRESA MUNDIAL LÍDER EN LOGÍSTICA',
      fr: 'LE LEADER MONDIAL DE LA LOGISTIQUE',
    },
    instructions: {
      en: 'PLEASE, CLICK THE SCREEN TO BEGIN',
      es: 'POR FAVOR, TOCA LA PANTALLA PARA COMENZAR',
      fr: "VEUILLEZ CLIQUER SUR L'ÉCRAN POUR COMMENCER",
    },
  },
  agent_auth_employee_number: {
    title: {
      es: 'Digita tu número de empleado',
      en: '',
      fr: '',
    },
    back_button: {
      es: 'REGRESAR',
      en: '',
      fr: '',
    },
  },
  agent_auth_yellow_password: {
    title: {
      es: 'Ingresa tu Yellow Password',
      en: '',
      fr: '',
    },
    instructions: {
      es: 'Por favor, escribe tu yellow password',
      en: '',
      fr: '',
    },
    continue_button: {
      es: 'VALIDAR',
      en: '',
      fr: '',
    },
    back_button: {
      es: 'REGRESAR',
      en: '',
      fr: '',
    },
  },
  agent_process_selection: {
    title: {
      es: '¿Qué operación deseas realizar?',
      en: '',
      fr: '',
    },
    insert: {
      es: 'Insertar piezas',
      en: '',
      fr: '',
    },
    retrieve: {
      es: 'Retirar piezas',
      en: '',
      fr: '',
    },
    deliver: {
      es: 'Entregar piezas',
      en: '',
      fr: '',
    },
    compartments: {
      es: 'Gavetas',
      en: '',
      fr: '',
    },
    cancel_button: {
      es: 'CANCELAR',
      en: '',
      fr: '',
    },
  },
  agent_locker_fix: {
    title: {
      es: 'Estado del locker',
      en: '',
      fr: '',
    },
    compartment: {
      es: 'Gaveta',
      en: '',
      fr: '',
    },
    state: {
      es: 'Estado',
      en: '',
      fr: '',
    },
    awb: {
      es: 'Guía asociada',
      en: '',
      fr: '',
    },
    free: {
      es: 'Libre',
      en: '',
      fr: '',
    },
    occupied: {
      es: 'Ocupado',
      en: '',
      fr: '',
    },
    damaged: {
      es: 'Dañado',
      en: '',
      fr: '',
    },
    test_button: {
      es: 'Probar apertura',
      en: '',
      fr: '',
    },
    select_compartment_instructions: {
      es: 'Selecciona una gaveta para ver más detalles.',
      en: '',
      fr: '',
    },
    fetching_feedback: {
      es: 'Buscando detalles del locker.',
      en: '',
      fr: '',
    },
    opening_feedback: {
      es: 'Abriendo...',
      en: '',
      fr: '',
    },
    close_compartment_instructions: {
      es: '¡Apertura exitosa! Por favor cierra el compartimiento.',
      en: '',
      fr: '',
    },
    updating_feedback: {
      es: 'Cierre exitoso, actualizando gaveta.',
      en: '',
      fr: '',
    },
    locker_content_failed: {
      es: 'No se pudo recuperar locker de CRA, regresa e intenta nuevamente',
      en: '',
      fr: '',
    },
    feedback_test_failed: {
      es: 'Tiempo excedido, reintenta o levanta un ticket en Request IT',
      en: '',
      fr: '',
    },
    feedback_content_update_failed: {
      es: 'Se actualizó CRA pero no logramos recuperar el estado del locker, regresa a intentar',
      en: '',
      fr: '',
    },
    feedback_api_update_failed: {
      es: 'No se pudo actualizar CRA, reintenta o levanta un ticket en Request IT',
      en: '',
      fr: '',
    },
    feedback_compartment_updated: {
      es: '¡Prueba exitosa!\nPodrás usar nuevamente el compartimiento',
      en: '',
      fr: '',
    },
    pre_test_instructions: {
      es: 'Para realizar una prueba asegurate que el compartimiento este cerrado. Si está abierto y no lo puedes cerrar, levanta un ticket en request IT',
      en: '',
      fr: '',
    },
    cancel_button: {
      es: 'REGRESAR',
      en: '',
      fr: '',
    },
  },
  client_retrieval_scan_awb: {
    title: {
      es: 'Ingresa o escanea el número de guía',
      en: '',
      fr: '',
    },
    subtitle: {
      es: 'Ingresa o escanea el número de guía',
      en: '',
      fr: '',
    },
    not_me: {
      es: 'No soy yo',
      en: '',
      fr: '',
    },
    back_button: {
      es: 'REGRESAR',
      en: '',
      fr: '',
    },
  },
  client_retrieval_verification_code: {
    title: {
      es: 'Escanea tu código QR o ingresa tu código de verificación',
      en: '',
      fr: '',
    },
  },
  client_retrieval_name: {
    title: {
      es: '¡Tenemos tu envío!',
      en: '',
      fr: '',
    },
    subtitle: {
      es: 'Guia: ',
      en: '',
      fr: '',
    },
    instructions: {
      es: 'Por favor, escribe tu nombre completo para la confirmación.',
      en: '',
      fr: '',
    },
    confirm_button: {
      es: 'CONFIRMAR',
      en: '',
      fr: '',
    },
  },
  client_retrieval_signature: {
    title: {
      es: '¡Tenemos tu envío!',
      en: '',
      fr: '',
    },
    subtitle: {
      es: 'Guia: ',
      en: '',
      fr: '',
    },
    instructions: {
      es: 'Por favor, firma sobre el recuadro para confirmar la recolección',
      en: '',
      fr: '',
    },
    clear_button: {
      es: 'Borrar',
      en: '',
      fr: '',
    },
    back_button: {
      es: 'REGRESAR',
      en: '',
      fr: '',
    },
    confirm_button: {
      es: 'CONFIRMAR',
      en: '',
      fr: '',
    },
  },
  client_retrieval_piece: {
    title: {
      es: '¡Gracias',
      en: '',
      fr: '',
    },
    subtitle: {
      es: 'Guía:',
      en: '',
      fr: '',
    },
    instructions: {
      es: 'Puedes retirar tu envío, por favor cierra la puerta para terminar, ¡Muchas gracias!',
      en: '',
      fr: '',
    },
    issue_button: {
      es: 'REPORTAR UN ERROR',
      en: '',
      fr: '',
    },
    confirm_button: {
      es: 'TERMINAR',
      en: '',
      fr: '',
    },
    other_piece_button: {
      es: 'TENGO OTRA GUÍA',
      en: '',
      fr: '',
    },
  },
  client_retrieval_issues: {
    title: {
      es: 'Por favor indícanos cual fue el problema',
      en: '',
      fr: '',
    },
    back_button: {
      es: 'CANCELAR',
      en: '',
      fr: '',
    },
    confirm_button: {
      es: 'CONFIRMAR',
      en: '',
      fr: '',
    },
    finish_button: {
      es: 'TERMINAR',
      en: '',
      fr: '',
    },
    other_piece_button: {
      es: 'TENGO OTRA PIEZA',
      en: '',
      fr: '',
    },
  },
  insert_scan_pid: {
    title: {
      es: 'Escanea el número de pieza PID',
      en: '',
      fr: '',
    },
    cancel_button: {
      es: 'CANCELAR',
      en: '',
      fr: '',
    },
  },
  insert_piece: {
    title: {
      es: 'Coloca la pieza en el compartimiento asignado',
      en: '',
      fr: '',
    },
    report_button: {
      es: 'REPORTAR ERROR',
      en: '',
      fr: '',
    },
    cancel_button: {
      es: 'CANCELAR',
      en: '',
      fr: '',
    },
    confirm_button: {
      es: 'CONFIRMAR',
      en: '',
      fr: '',
    },
  },
  insert_process_selection: {
    title: {
      es: 'Locker actualizado, ¿Qué deseas hacer?',
      en: '',
      fr: '',
    },
    insert: {
      es: 'Insertar otra pieza',
      en: '',
      fr: '',
    },
    finish: {
      es: 'Terminar',
      en: '',
      fr: '',
    },
  },
  insert_issues: {
    title: {
      es: 'Por favor indícanos cual fue el problema',
      en: '',
      fr: '',
    },
  },
  remove_validate_awb: {
    title: {
      es: 'Ingresa o escanea el número de guía',
      en: '',
      fr: '',
    },
    cancel_button: {
      es: 'CANCELAR',
      en: '',
      fr: '',
    },
  },
  remove_piece: {
    title: {
      es: 'Retira la guía del compartimiento indicado',
      en: '',
      fr: '',
    },
    report_button: {
      es: 'REPORTAR ERROR',
      en: '',
      fr: '',
    },
    cancel_button: {
      es: 'CANCELAR',
      en: '',
      fr: '',
    },
    confirm_button: {
      es: 'CONFIRMAR',
      en: '',
      fr: '',
    },
    next_button: {
      es: 'SIGUIENTE PIEZA',
      en: '',
      fr: '',
    },
    finish_button: {
      es: 'TERMINAR',
      en: '',
      fr: '',
    },
  },
  remove_process_selection: {
    title: {
      es: '¿Cómo deseas retirar las piezas?',
      en: '',
      fr: '',
    },
    remove: {
      es: 'Retirar guías vencidas',
      en: '',
      fr: '',
    },
    remove_exception: {
      es: 'Retirar guías con excepción',
      en: '',
      fr: '',
    },
    cancel_button: {
      es: 'REGRESAR',
      en: '',
      fr: '',
    },
  },
  remove_issues: {
    title: {
      es: 'Por favor indícanos cual fue el problema',
      en: '',
      fr: '',
    },
    back_button: {
      es: 'CANCELAR',
      en: '',
      fr: '',
    },
    confirm_button: {
      es: 'CONFIRMAR',
      en: '',
      fr: '',
    },
    finish_button: {
      es: 'TERMINAR',
      en: '',
      fr: '',
    },
  },
  thank_you: {
    title: {
      en: 'THANK YOU FOR CHOOSING DHL',
      es: 'GRACIAS POR ELEGIR DHL',
      fr: "Merci d'avoir choisi DHL",
    },
  },
  top_nav: {
    environment: {
      en: 'Environment',
      es: 'Ambiente',
      fr: 'Environnement',
    },
    installation: {
      en: 'Instalation',
      es: 'Instalación',
      fr: 'Installer',
    },
    location: {
      en: 'Location',
      es: 'Ubicación',
      fr: 'Emplacement',
    },
    country: {
      en: 'Country',
      es: 'País',
      fr: 'Pays',
    },
    kiosk_info_modal_button: {
      en: 'OK',
      es: 'OK',
      fr: "D'ACCORD",
    },
    logout_button: {
      en: 'Start Over',
      es: 'Reiniciar',
      fr: 'Recommencer',
    },
    next_button: {
      en: 'NEXT',
      es: 'SIGUIENTE',
      fr: 'SUIVANT',
    },
    previous_button: {
      en: 'BACK',
      es: 'REGRESAR',
      fr: 'RETOURNER',
    },
  },
  shell: {
    exit_session_message: {
      en: '',
      es: '¿Estás seguro que deseas cerrar la sesión?',
      fr: '',
    },
    exit_session_cancel_button: {
      en: '',
      es: 'Cancelar',
      fr: '',
    },
    exit_session_confirm_button: {
      en: '',
      es: 'Si, salir',
      fr: '',
    },
    user_timeout_message: {
      en: 'Your session is about to expire, do you wish to continue?',
      es: 'Tu sesión está por expirar, ¿Deseas continuar?',
      fr: "Votre session est sur le point d'expirer, souhaitez-vous continuer?",
    },
    user_timeout_cancel_button: {
      en: 'No, exit',
      es: 'No, salir',
      fr: 'Sans issue',
    },
    user_timeout_confirm_button: {
      en: 'Continue',
      es: 'Continuar',
      fr: 'Continuer',
    },
  },
  scanner_helper: {
    auth_message: {
      en: '',
      es: 'Por favor autoriza la conexión del puerto COM para el scanner de',
      fr: '',
    },
    auth_button: {
      en: '',
      es: 'AUTORIZAR',
      fr: '',
    },
  },
};
export const languages: string[] = ['es', 'en', 'fr'];
export const languageTags: any = {
  es: {
    base: 'ES',
    translation: '',
  },
  en: {
    base: 'EN',
    translation: '',
  },
  fr: {
    base: 'FR',
    translation: '',
  },
};
